import Button from 'components/UI/Button';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import { ORGANIZATION_CONSTANTS } from 'constants/organization';
import { USERS_BUSINESS_UNIT_CONSTANTS } from 'constants/usersBusinessUnit';
import User from 'data/User';
import { PermissionCode } from 'data/UserPermissions';
import React from 'react';
import styled from 'styled-components';
import { Main } from 'styles/themeColors';

const Heading = styled.span<any>`
  font-size: 24px;
  margin-bottom: 20px;
`;

interface Props {
    onCreate: (isParentBrand: boolean) => void;
    user: User;
    disabled?: boolean;
    activeTab?: number;
    toggleInviteModal: () => void;
    isAdminViewEnabled?: boolean;
}

const OrganizationHeader: React.FC<Props> = ({ onCreate, user, disabled, activeTab, toggleInviteModal, isAdminViewEnabled = true }: Props) => {


    return (
        <FlexboxContainerComponent justifyContent='space-between' width='100%' alignItems='center'>
            <Heading className='heading'>{ORGANIZATION_CONSTANTS.ORGANIZATION}</Heading>
            {
                activeTab === 0 && (
                    <FlexboxContainerComponent gap='8px'>
                        <Button
                            onClick={onCreate}
                            bgColor={Main.brandDark}
                            borderColor={Main.brandDark}
                            disabled={disabled}
                            permissionCode={PermissionCode.CREATE_BUSINESS_UNIT}
                        >
                            {ORGANIZATION_CONSTANTS.CREATE_BUSINESS_UNIT}
                        </Button>

                    </FlexboxContainerComponent>
                )
            }

            {
                activeTab === 1 && (
                    <FlexboxContainerComponent gap='8px'>
                        <Button
                            onClick={toggleInviteModal}
                            bgColor={Main.brandDark}
                            borderColor={Main.brandDark}
                            permissionCode={PermissionCode.INVITE_BUSINESS_UNIT}
                        >
                            {USERS_BUSINESS_UNIT_CONSTANTS.INVITE_USER}
                        </Button>
                    </FlexboxContainerComponent>
                )
            }

            {
                activeTab === ORGANIZATION_CONSTANTS.ADMINS_TAB_INDEX && (
                    <FlexboxContainerComponent gap='8px'>
                        <Button
                            onClick={toggleInviteModal}
                            bgColor={Main.brandDark}
                            borderColor={Main.brandDark}
                            disabled={!isAdminViewEnabled}
                        >
                            {USERS_BUSINESS_UNIT_CONSTANTS.INVITE_USER}
                        </Button>
                    </FlexboxContainerComponent>
                )
            }
        </FlexboxContainerComponent>
    );
};

export default React.memo(OrganizationHeader);